import { dbui_v1_Notable } from '@antimatterhq/asl-api-ts-v1';
import { exhaustiveMatchingGuard } from '@/utils/util';

export const getBadgeVariant = (state?: dbui_v1_Notable['state']) => {
  switch (state) {
    case 'Open':
      return 'danger';
    case 'Assigned':
      return 'warning';
    case 'ClosedAsFalsePositive':
    case 'ClosedAsBenignPositive':
    case 'ClosedAsTruePositiveResolved':
    case 'ClosedAsExported':
      return 'success';
    case undefined:
      return 'info';
    default:
      return exhaustiveMatchingGuard(state);
  }
};

export const getStatusText = (state?: dbui_v1_Notable['state']) => {
  switch (state) {
    case 'Open':
      return 'Open';
    case 'Assigned':
      return 'Assigned';
    case 'ClosedAsFalsePositive':
      return 'Closed as False Positive';
    case 'ClosedAsBenignPositive':
      return 'Closed as Benign Positive';
    case 'ClosedAsTruePositiveResolved':
      return 'Closed as True Positive Resolved';
    case 'ClosedAsExported':
      return 'Closed as Exported';
    case undefined:
      return '';
    default:
      return exhaustiveMatchingGuard(state);
  }
};
